var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWpf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9972467%",
    y1: "-19.5160457%",
    x2: "49.9972467%",
    y2: "129.625092%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994dc",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cef5",
    offset: "35.000601%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cef5",
    offset: "35.000601%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0007616%",
    y1: "-19.5161868%",
    x2: "50.0007616%",
    y2: "129.624154%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e76bc",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "36.0001%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "36.0001%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9991979%",
    y1: "110.921751%",
    x2: "49.9991979%",
    y2: "-6.21395776%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c63b7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    stopOpacity: 0.42,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0009899%",
    y1: "-19.5149993%",
    x2: "50.0009899%",
    y2: "129.627315%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166ab8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "39.999399%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "39.999399%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9985422%",
    y1: "-19.5211325%",
    x2: "49.9985422%",
    y2: "129.626892%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1487cb",
    offset: "38.9999%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1487cb",
    offset: "38.9999%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "78.022802%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "78.022802%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000304652977%",
    y1: "50.000544%",
    x2: "100.000291%",
    y2: "50.000544%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    stopOpacity: 0.698,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1dacd8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095709%",
    y1: "94.6864084%",
    x2: "50.0095709%",
    y2: "-3.02458407%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136ab4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59caf5",
    stopOpacity: 0.55,
    offset: "60.000002%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59caf5",
    stopOpacity: 0.235,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000760861053%",
    y1: "49.999714%",
    x2: "99.9992241%",
    y2: "49.999714%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    stopOpacity: 0.247,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9983236%",
    y1: "124.313712%",
    x2: "49.9983236%",
    y2: "-9.42137278%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ed5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38a7e4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.99857%",
    y1: "91.1999524%",
    x2: "49.99857%",
    y2: "-76.7854074%",
    id: "J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    stopOpacity: 0.55,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0000694%",
    y1: "100.01049%",
    x2: "50.0000694%",
    y2: "0.0101898204%",
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959a6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ec5ea",
    offset: "91.758698%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ec5ea",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.2036672%",
    y1: "94.5677442%",
    x2: "43.8808609%",
    y2: "5.75513731%",
    id: "L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d82ca",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9946843%",
    y1: "76.9980959%",
    x2: "49.9946843%",
    y2: "-3.29893613%",
    id: "M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0495d6",
    offset: "87.362701%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0495d6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.8856283%",
    y1: "-4.16143813%",
    x2: "43.9315204%",
    y2: "105.843625%",
    id: "N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38a7e4",
    stopOpacity: 0.33,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "96.153301%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "96.153301%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.016714%",
    y1: "-0.295776148%",
    x2: "50.016714%",
    y2: "101.881944%",
    id: "O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168cd4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c87cc",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#154b8d",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.6738062%",
    y1: "52.7065097%",
    x2: "87.8125992%",
    y2: "48.7849928%",
    id: "P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97d6ee",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55c1ea",
    offset: "70.329303%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55c1ea",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.89015912%",
    y1: "46.4539239%",
    x2: "75.7828966%",
    y2: "55.4182145%",
    id: "Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7accec",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fb7ed",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9966533%",
    y1: "6.36281892%",
    x2: "49.9966533%",
    y2: "127.96135%",
    id: "R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1da7e7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37abe7",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M0 .04h22.054v15.735H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M.11.05h15.03v15.728H.11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.076 35.26h-.7v2.188h-.285V35.26h-.702V35h1.687v.26zm2.864 2.188h-.284v-1.644l.023-.475-.076.24-.828 1.88h-.14l-.83-1.866a1.36 1.36 0 0 1-.075-.253h-.01a5.51 5.51 0 0 1 .013.479v1.64h-.273V35h.376l.746 1.7a2.23 2.23 0 0 1 .11.294h.01l.117-.3.76-1.7h.36v2.448h-.002zm-2.215 9.09c0-.133-.036-.23-.1-.3-.083-.067-.226-.103-.425-.103h-.287v.793h.346c.32 0 .477-.133.477-.4zm.447 1.653h-.394l-.25-.558c-.128-.28-.264-.42-.413-.42h-.212v.977h-.325v-2.325h.65c.3 0 .506.063.655.194a.56.56 0 0 1 .189.438c0 .16-.052.295-.155.406s-.246.2-.432.23v.01c.13.03.258.173.382.43l.304.62v.008zm.72-1.14c0-.457-.155-.844-.465-1.15s-.7-.46-1.136-.46c-.46 0-.845.154-1.15.462a1.57 1.57 0 0 0-.456 1.147c0 .464.158.85.47 1.16a1.54 1.54 0 0 0 1.134.46 1.54 1.54 0 0 0 1.134-.466c.312-.307.467-.694.467-1.155zm.218-.01c0 .513-.175.944-.528 1.3a1.77 1.77 0 0 1-1.3.523 1.77 1.77 0 0 1-1.295-.508c-.343-.338-.514-.77-.514-1.292a1.76 1.76 0 0 1 1.824-1.815c.5 0 .935.168 1.28.502.355.343.53.775.53 1.3zm-49.376 6.483h-1.12v-6.45c0-.5.033-1.13.093-1.86h-.025c-.105.428-.2.738-.285.93l-3.255 7.38h-.545l-3.26-7.326c-.092-.205-.188-.534-.285-.983h-.024c.034.385.054 1 .054 1.874v6.436H53V43.92h1.477l2.928 6.696c.22.504.364.888.433 1.15h.046l.457-1.178 3-6.668h1.4l.001 9.603zm3.476-.001h-1.115v-6.858H66.2v6.858zm.193-9.316a.68.68 0 0 1-.216.509c-.14.138-.316.208-.52.208a.73.73 0 0 1-.515-.201.68.68 0 0 1-.212-.517c0-.198.07-.367.212-.504s.316-.203.515-.203.38.066.52.203a.67.67 0 0 1 .216.504zm6.577 9c-.523.323-1.146.483-1.867.483-.977 0-1.764-.326-2.364-.978-.583-.633-.877-1.45-.877-2.45 0-1.123.32-2.033.963-2.724s1.5-1.038 2.584-1.038c.592 0 1.117.117 1.577.348v1.127c-.5-.36-1.046-.537-1.623-.537-.694 0-1.26.244-1.697.73-.456.498-.687 1.164-.687 1.995 0 .798.2 1.43.63 1.895s.98.696 1.685.696c.596 0 1.154-.197 1.676-.6v1.043zm5.204-5.428c-.192-.15-.468-.22-.833-.22-.443 0-.816.2-1.117.602-.342.45-.513 1.072-.513 1.867v3.496h-1.1v-6.858h1.1v1.414h.026c.16-.5.408-.886.74-1.16.3-.25.66-.375 1.044-.375.3 0 .506.032.654.093v1.14zm6.08 2.33c0-.878-.197-1.55-.6-2.008-.382-.442-.917-.663-1.604-.663-.678 0-1.222.224-1.63.67-.43.478-.645 1.152-.645 2.028 0 .82.205 1.465.617 1.925s.963.694 1.656.694c.717 0 1.266-.235 1.642-.702.37-.457.553-1.104.553-1.943m1.12-.04c0 1.093-.307 1.97-.918 2.628s-1.44 1-2.477 1c-1.023 0-1.837-.33-2.434-1-.585-.637-.88-1.478-.88-2.523 0-1.193.332-2.113 1-2.766.616-.606 1.44-.9 2.473-.9 1.016 0 1.8.32 2.382.95s.853 1.5.853 2.62m5.41 1.622c0 .562-.208 1.026-.626 1.397-.456.4-1.082.602-1.87.602-.645 0-1.2-.136-1.7-.413v-1.18c.534.437 1.124.657 1.77.657.864 0 1.296-.32 1.296-.958a.85.85 0 0 0-.287-.662c-.192-.175-.564-.385-1.12-.63-.57-.252-.977-.5-1.217-.777-.288-.318-.433-.73-.433-1.24a1.78 1.78 0 0 1 .673-1.42c.447-.377 1.024-.568 1.73-.568.542 0 1.026.107 1.457.32v1.105c-.45-.327-.963-.5-1.546-.5-.36 0-.65.1-.867.267s-.328.4-.328.7c0 .304.092.54.274.7.162.156.505.347 1.023.57.582.245 1.002.5 1.26.76.332.33.5.748.5 1.258m6.678-1.58c0-.878-.197-1.55-.592-2.008-.38-.442-.917-.663-1.603-.663-.678 0-1.222.224-1.63.67-.43.478-.643 1.152-.643 2.028 0 .82.205 1.465.614 1.925.415.462.968.694 1.66.694.718 0 1.266-.235 1.642-.702.37-.457.553-1.104.553-1.943m1.12-.04c0 1.093-.3 1.97-.922 2.628s-1.437 1-2.474 1c-1.024 0-1.838-.33-2.435-1-.585-.637-.88-1.478-.88-2.523 0-1.193.335-2.113.997-2.766.616-.606 1.442-.9 2.476-.9 1.016 0 1.8.32 2.38.95s.857 1.5.857 2.62m4.807-5.73c-.215-.12-.453-.18-.725-.18-.764 0-1.143.484-1.143 1.453v1.057h1.597v.93h-1.597v5.928h-1.092v-5.928h-1.16v-.93h1.16v-1.112c0-.755.23-1.347.697-1.774.4-.37.9-.555 1.472-.555.337 0 .6.04.8.12v1zm4.306 9.118c-.258.15-.6.222-1.025.222-1.2 0-1.784-.675-1.784-2.024v-4.056h-1.17v-.93h1.17V45l1.093-.356v2.03h1.716v.93h-1.716v3.87c0 .46.075.8.23.98.158.197.415.294.78.294a1.15 1.15 0 0 0 .706-.221v.936z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.84 20.57c1.933 5.957 2.666 16.583 8.32 16.583a6.91 6.91 0 0 0 1.302-.126c-5.14-1.207-5.748-11.718-8.884-17.16a26.1 26.1 0 0 0-.737.704",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.575 19.865c3.136 5.443 3.745 15.954 8.884 17.16a8.13 8.13 0 0 0 1.214-.33c-4.613-2.277-5.888-12.484-9.45-17.397a22.24 22.24 0 0 0-.649.567",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.094 16.628a6.93 6.93 0 0 0-1.303.126c-1.144.217-2.306.714-3.477 1.465a8.68 8.68 0 0 1 .911 1.08c1.19-.996 2.375-1.732 3.554-2.175.443-.165.883-.29 1.326-.37-.32-.082-.656-.124-1.01-.124",
    fill: "#14559a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.274 34.597l1.418-1.252c-1.964-5.93-2.667-16.707-8.36-16.707a6.69 6.69 0 0 0-1.228.115c5.185 1.3 5.85 12.667 8.17 17.845",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.104 16.752a4.06 4.06 0 0 0-1.011-.124l2.24.008a6.61 6.61 0 0 0-1.228.116",
    fill: "#3092c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.174 35.856c-.223-.214-.434-.45-.642-.7-.958.683-1.912 1.2-2.86 1.54a4.38 4.38 0 0 0 1.066.366c.29.06.592.1.908.1 1.064 0 1.905-.127 2.62-.473a4.98 4.98 0 0 1-1.094-.823",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.778 17.125c4.645 2.448 5.048 13.532 8.754 18.033.248-.176.494-.363.74-.56-2.32-5.178-2.983-16.546-8.168-17.845a7.98 7.98 0 0 0-1.327.373",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.224 19.298c3.56 4.914 4.836 15.12 9.45 17.397.948-.337 1.902-.855 2.86-1.54-3.706-4.5-4.1-15.585-8.754-18.033-1.18.442-2.363 1.178-3.554 2.174",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.56 20.426c-.558 1.272-1.128 2.943-1.818 5.125 1.37-1.946 2.737-3.623 4.096-4.98-.187-.58-.388-1.114-.605-1.59-.556.43-1.115.91-1.674 1.447",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 18.612l-.494.367c.216.476.417 1.01.604 1.59l.737-.704c-.263-.455-.543-.876-.846-1.253",
    fill: "#2b74b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.314 18.22l-.585.393c.304.377.583.798.847 1.254l.65-.568a8.68 8.68 0 0 0-.911-1.08",
    fill: "#125a9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.993 16.175C104.367 26.382 98.88 34.58 94.28 36.647l-.257.107c-.01.007-.022.008-.03.012-.024.01-.047.017-.07.027-.01.007-.022.01-.032.013-.04.014-.077.026-.115.04-.016.007-.032.01-.047.017s-.037.013-.057.02-.035.012-.055.02-.034.01-.05.017c-.034.01-.065.018-.098.03-.014 0-.027.008-.04.01-.02.007-.044.012-.066.018-.016.007-.028.01-.045.013a1.44 1.44 0 0 1-.072.019l-.088.02a1.86 1.86 0 0 0 .658.116c4.362 0 8.76-7.876 16.036-20.973h-2.857l.001.002z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.796 17.042c.01-.007.017-.007.018-.014.03-.008.052-.018.076-.027s.026-.014.032-.015l.076-.027c.062-.017.115-.04.17-.06.008 0 .016-.007.025-.007l.072-.022c.01-.007.022-.007.033-.01l.072-.022c.01 0 .02-.007.028-.008l.24-.063c.01 0 .02-.007.033-.008.023-.007.045-.01.07-.014.01-.007.022-.007.035-.01.023-.007.046-.008.07-.013l.162-.027h.03c.023-.007.044-.008.067-.012.013 0 .026-.007.038-.007.022 0 .043-.007.065-.01.01 0 .022 0 .035-.007l.157-.014-.464-.024c-4.912 0-11.68 9.183-14.728 21.076h.587a172.63 172.63 0 0 0 2.654-4.968c2.135-8.424 6.484-14.168 10.347-15.7",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.56 20.426c.558-.536 1.118-1.02 1.674-1.447l-.4-.776c-.45.55-.86 1.274-1.275 2.223m.405-3.314c.32.27.608.644.87 1.1l.254-.286a4.95 4.95 0 0 0-1.187-.837c.017.01.035.017.052.025",
    fill: "#0d82ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.45 32.732c4.48-8.697 6.6-14.2 10.347-15.7-3.862 1.523-8.212 7.268-10.347 15.7",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09 17.917l-.254.286c.14.237.272.495.4.776l.494-.367c-.203-.252-.417-.486-.64-.695",
    fill: "#127bca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.482 37.662c-.028.007-.055.007-.08.01-.04 0-.063.007-.085.007l-.176.01h-.017c4.533-.128 6.605-2.415 7.634-5.732l1.986-6.4c-1.9 2.693-3.806 5.903-5.724 9.5-.925 1.733-2.33 2.457-3.537 2.612",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.482 37.66c1.206-.155 2.612-.878 3.537-2.612 1.918-3.595 3.826-6.806 5.723-9.5.7-2.183 1.26-3.853 1.818-5.125-3.78 3.626-7.577 9.656-11.078 17.234",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.45 32.732L56.795 37.7h1.71a42.37 42.37 0 0 1 .945-4.968",
    fill: "#05a1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.243 16.667c-.014 0-.024.007-.036.007-.02.007-.042.007-.064.01-.013 0-.025 0-.038.007-.023.007-.045.008-.067.012-.01 0-.02 0-.03.007l-.146.026h-.016a.57.57 0 0 1-.071.014c-.012.007-.024.007-.035.01-.023.007-.047.01-.07.014-.012.007-.022.007-.033.008l-.24.063c-.01 0-.017.007-.028.008l-.072.022c-.01.007-.022.007-.033.01l-.072.022c-.01 0-.017.007-.026.007l-.166.06-.076.026c-.01.007-.02.008-.032.013-.024.008-.048.017-.07.026-.01.007-.017.008-.023.01-3.746 1.5-5.868 6.994-10.347 15.7-.398 1.566-.72 3.227-.945 4.968h.24l1.958-.007h.438c.053-.007.11-.007.165-.01h.01c.023 0 .047-.007.07-.007h.016c.025 0 .053-.007.08-.01 3.502-7.578 7.297-13.608 11.078-17.234.416-.95.826-1.674 1.274-2.223-.262-.447-.55-.82-.87-1.092l-.01-.007c-.018-.008-.035-.017-.053-.026s-.034-.017-.053-.027a.57.57 0 0 1-.052-.025c-.022-.007-.04-.017-.06-.026s-.03-.014-.047-.02a2.01 2.01 0 0 1-.099-.042c-.015-.007-.028-.01-.042-.016-.023-.008-.05-.02-.074-.03-.012-.007-.026-.008-.04-.013l-.103-.035h-.01c-.04-.013-.08-.023-.12-.034-.01-.007-.017-.007-.027-.008l-.1-.03c-.01 0-.016-.007-.023-.007a3.52 3.52 0 0 0-.249-.055c-.01 0-.017-.007-.026-.007-.036-.007-.072-.013-.108-.017-.01-.007-.014-.007-.022-.007-.043-.007-.085-.012-.128-.017h-.022c-.035-.007-.066-.008-.098-.01-.054.007-.106.01-.157.015",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.733 21.825L94.566 28.8c2.365-3.28 4.694-7.403 6.912-12.163-2.587.82-3.967 2.693-4.745 5.2",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64 36.473l-.36.174c4.6-2.067 10.086-10.265 12.713-20.473h-.532c-6.035 10.863-7.976 18.134-11.82 20.3",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.638 35.56c1-1.23 1.816-3.323 2.93-6.77-1.284 1.777-2.576 3.304-3.87 4.55.275.863.585 1.615.938 2.222",
    fill: "#079ae1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.638 35.56c-.34.42-.7.738-1.102.974l-.267.144c.424.23.886.384 1.404.446l.23.02h.014a.61.61 0 0 1 .11.007h.374c.014 0 .028 0 .042-.007.027 0 .055 0 .083-.007h.04c.028 0 .06-.007.1-.01.016 0 .025-.007.034-.007.032-.007.065-.01.096-.015h.028l.108-.018h.007l.225-.046c-.594-.22-1.1-.735-1.518-1.47",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1e5cb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.157 37.152c.43 0 .865-.042 1.302-.127.404-.074.808-.187 1.214-.33a4.39 4.39 0 0 0 1.065.366c.29.06.593.1.91.1h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.648 37.152c1.063 0 1.905-.127 2.62-.473.424.23.886.384 1.404.446l.23.02h.014a.61.61 0 0 1 .11.007h.13-4.51.003z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.156 37.152h.246c.015 0 .028 0 .042-.007.027 0 .055 0 .084-.007h.04c.028 0 .06-.007.09-.01.017 0 .025-.007.034-.007.032-.007.065-.01.096-.015.01 0 .02 0 .03-.007l.108-.017h.007l.225-.046a1.86 1.86 0 0 0 .658.116l-1.658.007-.001-.008z",
    fill: "#1d60b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.693 33.35l-1.418 1.246-.74.56c.208.25.42.485.642.7.338.33.7.608 1.094.823l.267-.144a4.1 4.1 0 0 0 1.103-.974c-.353-.607-.663-1.36-.945-2.2",
    fill: "#175fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.776 16.175h-2.68l-.424.02-.198.426c-2.218 4.76-4.547 8.884-6.912 12.163-1.112 3.448-1.928 5.54-2.93 6.77.428.735.926 1.252 1.517 1.472.017-.007.03-.007.047-.01h.01c.01 0 .022-.007.033-.007.024-.007.05-.01.074-.02.016-.007.028-.008.044-.013.022-.007.046-.012.066-.017.014-.007.028-.01.04-.012.035-.01.066-.02.098-.03.016-.007.032-.013.05-.017s.038-.012.055-.02.04-.01.057-.018.032-.01.047-.017c.04-.014.077-.026.116-.04.01 0 .02-.01.032-.012.023-.01.047-.017.07-.028.01-.007.02-.008.03-.01l.248-.107h.01c.12-.053.24-.112.36-.174 3.845-2.164 5.786-9.436 11.82-20.3h-1.686.002z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 16.652c.01 0 .018 0 .028.007a.22.22 0 0 1 .07.008h.023l.128.017c.008 0 .015 0 .022.007l.108.018c.008 0 .018.007.027.007l.248.056c.008 0 .016.007.022.007l.1.028c.01 0 .018.007.028.008l.118.034.112.042c.014.007.027.01.04.013l.074.03c.014 0 .028.01.042.015l.098.042.048.02c.02.01.04.02.06.026l.053.025.053.027a4.95 4.95 0 0 1 1.187.837c.135-.143.275-.27.42-.385a4.61 4.61 0 0 0-2.745-.895l-.364.016",
    fill: "#7dcbec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09 17.917c.223.21.437.443.64.695l.585-.393c-.255-.257-.525-.49-.805-.688-.146.114-.286.243-.42.385",
    fill: "#5ec5ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.82 1.6l.364.015c1.043 0 1.947-.325 2.745-.894.842.67 1.86.903 3.274.903H.355c.158 0 .312-.01.464-.023",
    transform: "matrix(1 0 0 -1 70.581498 18.252849)",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.625C2.337 1.625 1.32 1.39.477.72a6.23 6.23 0 0 0 .804-.688C2.453.785 3.615 1.282 4.76 1.5c.437.083.872.125 1.302.125h-2.3z",
    transform: "matrix(1 0 0 -1 74.03213 18.252849)",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.566 28.79l2.168-6.966c.778-2.507 2.156-4.38 4.743-5.2l.2-.426c-4.218.255-6.19 2.416-7.18 5.618-1.735 5.59-2.786 9.212-3.797 11.52 1.292-1.245 2.585-2.773 3.868-4.548",
    fill: "url(#R)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "U",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.444 15.422l-.098-.93c.085-.53.11-1.062-.02-1.59-.378-2.017-.045-4.075-.358-6.095-.017-.2.012-.462-.274-.46-.22.003-.354.187-.388.415L5.488 14.9c-.284.62-.622.917-1.34.87-.963-.063-1.933-.037-2.9-.007-.6.02-.87-.173-.884-.815L.001.977C-.018.32.168.016.873.05l2.453.002c.7-.03.885.232.855.92L3.986 8.07c-.006.306-.142.743.307.84.425.09.528-.32.663-.617L8.217 1C8.537.238 8.96.003 9.73.05c.852.054 1.714.063 2.564-.002.866-.066 1.056.29 1.05 1.094l.102 7.214c.005.282-.087.665.277.76.476.126.496-.34.613-.62l3.13-7.59c.24-.598.53-.902 1.215-.86.89.054 1.785.032 2.676.008.707-.02.85.224.547.86L17.037 11.26l-1.782 3.823c-.227.523-.52.73-1.094.682-1.178-.1-2.37.126-3.545-.124l-.172-.22",
    fill: "#0b5895",
    mask: "url(#U)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.595 7.07c1.065.042 1.985-.266 2.643-1.14a1.9 1.9 0 0 0 .228-2.001c-.272-.602-.855-.724-1.502-.73-1.893-.014-1.894-.033-2.34 1.744l-.16.76c-.26 1.368-.26 1.368 1.13 1.366zM28.427.256l3.566.01c3.245.184 4.897 2.824 3.744 5.867-1.04 2.74-3.228 3.7-5.93 3.858-.74.046-1.49.055-2.228-.003-.78-.06-1.16.243-1.298 1l-.823 4.126c-.11.666-.426.852-1.05.83-.965-.035-1.934-.053-2.897.005-.846.05-.917-.336-.77-1.01L23.774.877c.13-.62.512-.635.974-.635h3.68v.014z",
    fill: "#0b5895"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.824 .181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.294.062l5.02-.012c.728-.015.94.275.775.935-.115.466-.276.927-.33 1.4-.072.62-.394.78-.976.77-1.747-.028-3.498.046-5.242-.034-.953-.044-1.295.322-1.478 1.2-.492 2.355-.414 1.953 1.588 1.972l4.24-.004c.63-.008.825.137.663.846-.468 2.05-.425 2.06-2.498 2.06-1.302 0-2.606.05-3.904-.018-.924-.05-1.244.397-1.395 1.197l-.908 4.444c-.13.7-.426 1-1.186.953-.925-.07-1.86-.037-2.788-.008-.634.02-.872-.157-.72-.84L3.177.952c.166-.806.536-.9 1.21-.9l4.908.01",
    fill: "#0b5895",
    mask: "url(#V)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpf);
export default __webpack_public_path__ + "static/media/WPF.b730f5813a856e592b001ce88fe86f0c.svg";
export { ForwardRef as ReactComponent };